import { render, staticRenderFns } from "./SkeletonMediaObject.vue?vue&type=template&id=047a015b&"
import script from "./SkeletonMediaObject.vue?vue&type=script&lang=js&"
export * from "./SkeletonMediaObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports